(function () {
  'use strict';

  function applyAccessibilityFixes() {
    document.querySelectorAll('.owl-dots').forEach(function (group) {
      group.querySelectorAll('button.owl-dot').forEach(function (dot, index) {
        if (!dot.getAttribute('aria-label')) dot.setAttribute('aria-label', 'Show slide ' + (index + 1));
      });
    });

    document.querySelectorAll('img.gf_youtube-thumb:not([alt])').forEach(function (image) {
      image.setAttribute('alt', 'Video preview');
    });

    var headingLevels = [
      ['.product-single__title', '2'],
      ['body.page-title--yolink-contact-us #e-1701812050313 h3', '2'],
      ['body.template-cart .title-bar h3', '2'],
      ['body.template-search h4.search-page-title', '2'],
      ['body.page-title--raedius #e-1704321731096 h4', '3']
    ];
    headingLevels.forEach(function (item) {
      document.querySelectorAll(item[0]).forEach(function (heading) {
        heading.setAttribute('role', 'heading');
        heading.setAttribute('aria-level', item[1]);
      });
    });

    function replaceHeading(selector, tagName) {
      document.querySelectorAll(selector).forEach(function (heading) {
        if (heading.tagName.toLowerCase() === tagName) return;
        var replacement = document.createElement(tagName);
        Array.from(heading.attributes).forEach(function (attribute) {
          if (attribute.name !== 'role' && attribute.name !== 'aria-level') replacement.setAttribute(attribute.name, attribute.value);
        });
        replacement.innerHTML = heading.innerHTML;
        heading.replaceWith(replacement);
      });
    }
    replaceHeading('body.page-title--yolink-contact-us main h4', 'h3');
    replaceHeading('body.page-title--raedius main h4', 'h2');

    var previewFrame = document.getElementById('PBarNextFrame');
    if (previewFrame && !previewFrame.getAttribute('title')) previewFrame.setAttribute('title', 'Shopify theme preview controls');
  }

  function ready() {
    applyAccessibilityFixes();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        applyAccessibilityFixes();
      });
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openMenu = document.querySelector('.yl-global-header details[open]');
      if (!openMenu) return;
      openMenu.removeAttribute('open');
      var summary = openMenu.querySelector(':scope > summary');
      if (summary) summary.focus();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
